import AOS from 'aos';

export function initAOS() {
	AOS.init({
		startEvent: 'DOMContentLoaded',
		initClassName: 'aos-init',
		animatedClassName: 'aos-animate',
		useClassNames: false,
		disableMutationObserver: false,
		debounceDelay: 50,
		throttleDelay: 99,
		offset: 130,
		delay: 300,
		duration: 400,
		easing: 'ease-in-out',
		once: false,
		mirror: false,
		anchorPlacement: 'top-bottom',
	});
}

export { AOS };
